<template>
    <div class="session__show_sessions" v-if="sessions.length">
        <div class="session__show_sessions_header">
            <view-actions
                :title="$t('ebs.sessions.show.title.otherEvent')"
                :cancel-button-active="false"
                :submit-button-active="false"
                :link-button-active="true"
                :link-button-text="$t('ebs.sessions.show.buttons.viewAll')"
                :link-button-outline="true"
                :link-button-to="{ name: 'ebs-event-show', params: { id: $route.params.eventId } }"
                @emit-submit="viewAllSessions"
            />
        </div>
        <div class="session__show_sessions_main">
            <div class="container">
                <div class="columns columns--custom is-multiline">
                    <template v-for="(session, index) in sessions">
                        <div
                            class="column column--custom is-4-desktop is-8-tablet is-12-mobile"
                            :key="index">
                            <session-list-grid-item
                                :session="session"
                            />
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import SessionListGridItem from '@/components/ebs/sessions/list/SessionListGridItem'

export default {
  components: {
    SessionListGridItem,
    ViewActions
  },
  name: 'session-show-sessions',
  methods: {
    viewAllSessions: function () {

    }
  },
  computed: {
    sessions: function () {
      const sessionsObject = this.$store.getters.getEventOccurrences
      return sessionsObject.filter(obj => {
        return obj.id !== this.$route.params.sessionId
      })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionshowsessions";
</style>
